<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Product was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Product - {{ this.product.name }}</h1>
    <app-audit-line [data]='this.product'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-product-form [product]='this.product'></app-product-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-secondary" [routerLink]='"/warehousing/products/label/" + this.product.id'><i class="fas fa-print"></i> Print Label</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/quoting/products'>Cancel</button>
    </form>
  </div>
</div>
